export enum ActorType {
    AGENT = 'agent',
    BOT = 'bot',
    USER = 'user',
}

export enum SourceType {
    QUESTION = 'question',
    TICKET = 'ticket',
    WIDGET = 'widget',
}

export enum WidgetType {
    REFUND_TIMELINE = 'refund-timeline',
}

export enum InputType {
    BUTTON = 'button',
    FILE = 'file',
    FORM = 'form',
    MULTISELECT = 'multiselect',
    SELECT = 'select',
    TEXT = 'text',
    TEXTAREA = 'textarea',
}

export enum StateType {
    ASSIGNMENT = 'assignment',
    RESOLUTION = 'resolution',
}

export enum WidgetName {
    BOOKING_CONFIRMATION = 'booking_confirmation',
    BOOKING_SELECTION = 'booking_selection',
    FARE_SUMMARY = 'fare_summary',
    HTML = 'html',
    NPS_COLLECTION = 'nps_collection',
    PAX_MODIFICATION = 'pax_modification',
    QUERY_RESOLUTION = 'query_resolution',
    REFUND_TIMELINE = 'refund_timeline',
    STATE = 'state',
    TDR_REASON_SELECTION = 'tdr_reason_selection',
    IFRAME = 'iframe',
}
